import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useQuery } from 'react-query'

export interface Timezone {
  id: string
  name: string
}

type Data = Timezone[]

const fetchTimezones = async () => {
  const res = await sendToApi<{ timezones: Timezone[] }>('/timezones')
  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }
  return res.data.timezones
}

export const useTimezones = () => {
  return useQuery<Data>('timezones', fetchTimezones, {
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  })
}
